import { queryOptions, useQuery } from '@tanstack/react-query';

import { QueryOptions } from '@cast/shared-types';
import { makeIsEnabled } from '@cast/utils';

import { apiClient } from '@cast/infrastructure-api';
import { DboGetCacheQueryTemplateResponse } from '@cast/types-database-optimizer';

const apiFn = apiClient.dbo.getProxyCacheQueryTemplate;

type Params = Parameters<typeof apiFn>[0];

const DBO_PROXY_CACHE_QUERY_TEMPLATE_KEY = 'dbo-proxy-cache-query-template';

const getQueryKey = (params: Params) =>
  [DBO_PROXY_CACHE_QUERY_TEMPLATE_KEY, params] as const;

export const useDatabaseProxyCacheQueryTemplateQuery = <
  TSelected = DboGetCacheQueryTemplateResponse
>(
  params: Params,
  options?: QueryOptions<DboGetCacheQueryTemplateResponse, TSelected>
) =>
  useQuery(
    queryOptions({
      queryKey: getQueryKey(params),
      queryFn: async () => {
        const { data } = await apiFn(params);
        return data;
      },
      enabled: makeIsEnabled(
        !!params.organizationId,
        !!params.proxyId,
        !!params.databaseName,
        !!params.templateHash,
        options?.enabled ?? true
      ),
      ...options,
    })
  );
